import { BaseWeekDays, BaseWeekDaysAlt, BaseInquiryShifts } from '../../modules/inquiry/_enums/base-inquiry.enum';

export const ShiftsArray = Object.values(BaseInquiryShifts);
export const WeekdaysArray = Object.values(BaseWeekDays);
export const WeekdaysArrayAlt = Object.entries(BaseWeekDaysAlt) as [BaseWeekDays, BaseWeekDaysAlt][];
export const WeekdaysIndexesArray = WeekdaysArray.map((weekday, index) => index);
